import { axiosDeletePromise, axiosGet, axiosGetNoHeader, axiosPostPromise, ApiResponse } from '../utils/apiHelpers';
import { endPoints } from '../localisation/ApiUrls.en';

// AuthService centralises user/auth related API calls.
export interface LoginRequest {
    username: string;
    password: string;
}

export type ResetPasswordRequest =
    | { resetcode: string; newpassword: string }
    | { verificationCode: string; newPassword: string };

export const AuthService = {
    login: (payload: LoginRequest): Promise<ApiResponse> => axiosPostPromise(endPoints.login, payload, true),

    requestPasswordReset: (email: string): Promise<ApiResponse> => axiosGetNoHeader(endPoints.resetPassword(email)),

    /**
     * Submit a new password using a reset code (preferred name).
     * `resetPasswordNow` is kept as a backward-compatible alias.
     */
    resetPassword: (email: string, payload: ResetPasswordRequest): Promise<ApiResponse> =>
        axiosPostPromise(endPoints.resetPasswordNow(), {...payload, email}, false),

    /** @deprecated Use `resetPassword` instead. */
    resetPasswordNow: (email: string, payload: ResetPasswordRequest): Promise<ApiResponse> =>
        axiosPostPromise(endPoints.resetPasswordNow(), {...payload, email}, false),

    changePassword: (payload: { currentpassword: string; newpassword: string }): Promise<ApiResponse> =>
        axiosPostPromise(endPoints.changePassword, payload, false),

    refreshToken: (payload: unknown): Promise<ApiResponse> =>
        axiosPostPromise(endPoints.refreshToken, payload, false),

    getLoggedInDetail: (): Promise<ApiResponse> => axiosGet(endPoints.loggedInDetail),

    inviteUser: (payload: unknown): Promise<ApiResponse> => axiosPostPromise(endPoints.inviteUser, payload, false),

    userRegistrationValidate: (payload: unknown): Promise<ApiResponse> =>
        axiosPostPromise(endPoints.userRegistrationValidate, payload, false),

    userRegistration: (payload: unknown): Promise<ApiResponse> =>
        axiosPostPromise(endPoints.userRegistration, payload, false),

    getUserListBySite: (siteId: string): Promise<ApiResponse> => axiosGet(endPoints.getUserListBySite(siteId)),

    getUserDetail: (userId: string): Promise<ApiResponse> => axiosGet(endPoints.getUserDetail(userId)),

    getAllUsers: (): Promise<ApiResponse> => axiosGet(endPoints.getAllUsers),

    deleteUserProfile: (siteId: string): Promise<ApiResponse> =>
        axiosDeletePromise(endPoints.deleteUserProfile(siteId), false),
};
